import { PROVIDERS_FILTER_GROUP_NAME } from '@/constants/filters';
import { BundleFilterOptions } from '@/api';

export const isProvidersFilter = (filterOption: BundleFilterOptions) => {
  return filterOption.groupName === PROVIDERS_FILTER_GROUP_NAME;
};
